/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

// The mobile cart owns its viewport and scroll lock only while its dialog is open.
const mobileCart = (() => {
  const breakpoint = window.matchMedia('(max-width: 798px)');
  let dialog;
  let closeButton;
  let active;
  let initialized = false;

  function saveStyles(element, properties) {
    return properties.map(name => ({
      name,
      value: element.style.getPropertyValue(name),
      priority: element.style.getPropertyPriority(name),
    }));
  }

  function restoreStyles(element, properties) {
    properties.forEach(({ name, value, priority }) => {
      if (value) element.style.setProperty(name, value, priority);
      else element.style.removeProperty(name);
    });
  }

  function syncViewport() {
    if (!active) return;
    const viewport = window.visualViewport;
    dialog.style.setProperty('--esl-cart-viewport-height', `${viewport ? viewport.height : window.innerHeight}px`);
    dialog.style.setProperty('--esl-cart-viewport-top', `${viewport ? viewport.offsetTop : 0}px`);
  }

  function refresh() {
    if (!active) return;
    const title = active.surface.querySelector('.ajax-cart__cart-title');
    const label = title && title.textContent.trim()
      || active.trigger && (active.trigger.getAttribute('aria-label') || active.trigger.textContent.trim());
    if (label) dialog.setAttribute('aria-label', label);
    syncViewport();
  }

  function close(restoreFocus = true) {
    if (!active) return false;
    const state = active;
    active = null;
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', syncViewport);
      window.visualViewport.removeEventListener('scroll', syncViewport);
    }
    if (dialog.open) dialog.close();
    state.surface.classList.remove('esl-mobile-cart-surface');
    if (state.nextSibling && state.nextSibling.parentNode === state.parent) {
      state.parent.insertBefore(state.surface, state.nextSibling);
    } else {
      state.parent.appendChild(state.surface);
    }
    restoreStyles(document.body, state.bodyStyles);
    restoreStyles(document.documentElement, state.rootStyles);
    // Restore immediately even when the theme enables smooth scrolling globally.
    const scrollStyles = saveStyles(document.documentElement, ['scroll-behavior']);
    document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo({ left: state.scrollX, top: state.scrollY, behavior: 'instant' });
    restoreStyles(document.documentElement, scrollStyles);
    if (restoreFocus && state.trigger && state.trigger.isConnected
      && document.activeElement !== state.trigger) {
      state.trigger.focus({ preventScroll: true });
    }
    return true;
  }

  function closeFromTheme(restoreFocus = true) {
    if (!active) return;
    const api = window.PXUTheme.jsAjaxCart;
    if (active.action === 'drawer') api.hideDrawer(restoreFocus);
    else api.hideMiniCart(active.trigger, restoreFocus);
  }

  function ensureDialog() {
    if (dialog) return true;
    const candidate = document.createElement('dialog');
    if (typeof candidate.showModal !== 'function') return false;
    dialog = candidate;
    dialog.className = 'esl-mobile-cart-dialog';
    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'esl-mobile-cart-close';
    closeButton.setAttribute('data-ajax-cart-close', '');
    const icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '\u00d7';
    closeButton.appendChild(icon);
    closeButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      closeFromTheme();
    });
    dialog.appendChild(closeButton);
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      closeFromTheme();
    });
    dialog.addEventListener('close', () => {
      if (!dialog.open) closeFromTheme();
    });
    document.body.appendChild(dialog);
    return true;
  }

  function open(surface, trigger) {
    if (!breakpoint.matches || !surface || !ensureDialog()) return false;
    if (active) return active.surface === surface;
    const body = document.body;
    const root = document.documentElement;
    active = {
      surface,
      trigger: trigger || document.activeElement,
      action: window.PXUTheme.jsAjaxCart.cart_action,
      parent: surface.parentNode,
      nextSibling: surface.nextSibling,
      scrollX: window.scrollX || 0,
      scrollY: window.scrollY || window.pageYOffset || 0,
      bodyStyles: saveStyles(body, ['position', 'top', 'left', 'width', 'overflow']),
      rootStyles: saveStyles(root, ['overflow']),
    };
    closeButton.setAttribute('aria-label', surface.dataset.eslCartCloseLabel
      || surface.querySelector('[data-ajax-cart-close]')?.getAttribute('aria-label')
      || active.trigger?.getAttribute('aria-label') || '');
    surface.classList.add('esl-mobile-cart-surface');
    dialog.appendChild(surface);
    body.style.setProperty('position', 'fixed', 'important');
    body.style.setProperty('top', `${-active.scrollY}px`, 'important');
    body.style.setProperty('left', `${-active.scrollX}px`, 'important');
    body.style.setProperty('width', '100%', 'important');
    body.style.setProperty('overflow', 'hidden', 'important');
    root.style.setProperty('overflow', 'hidden', 'important');
    refresh();
    try {
      dialog.showModal();
    } catch (error) {
      close(false);
      return false;
    }
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncViewport);
      window.visualViewport.addEventListener('scroll', syncViewport);
    }
    closeButton.focus({ preventScroll: true });
    return true;
  }

  function openMiniCart(focusTrigger) {
    if (!breakpoint.matches || window.PXUTheme.jsAjaxCart.cart_action !== 'mini_cart') return false;
    const trigger = document.querySelector('.mobile-header [data-ajax-cart-trigger]');
    const container = trigger && trigger.closest('.header-cart');
    const surface = active && active.surface || container && container.querySelector('.theme-ajax-cart');
    if (!container || !open(surface, focusTrigger || trigger)) return false;
    container.classList.add('show-mini-cart');
    trigger.setAttribute('aria-expanded', 'true');
    return true;
  }

  function onResize() {
    if (!breakpoint.matches) closeFromTheme(false);
    else syncViewport();
  }

  function onPageTransition() {
    closeFromTheme(false);
  }

  function init() {
    if (initialized) return;
    initialized = true;
    window.addEventListener('resize', onResize);
    window.addEventListener('pagehide', onPageTransition);
    window.addEventListener('pageshow', onPageTransition);
    if (breakpoint.addEventListener) breakpoint.addEventListener('change', onResize);
    else breakpoint.addListener(onResize);
  }

  function destroy() {
    closeFromTheme(false);
    if (!initialized) return;
    initialized = false;
    window.removeEventListener('resize', onResize);
    window.removeEventListener('pagehide', onPageTransition);
    window.removeEventListener('pageshow', onPageTransition);
    if (breakpoint.removeEventListener) breakpoint.removeEventListener('change', onResize);
    else breakpoint.removeListener(onResize);
    if (dialog) dialog.remove();
    dialog = null;
    closeButton = null;
  }

  return { init, destroy, open, close, refresh, openMiniCart, isMobile: () => breakpoint.matches };
})();


window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    mobileCart.init();

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document)
        .off('click.ajaxCartDrawer', '[data-ajax-cart-trigger]')
        .on('click.ajaxCartDrawer', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer(this);

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      // Bind even when loaded on desktop, so resizing into mobile remains usable.
      this.toggleMiniCart();
      this.showMiniCartOnHover();
    }

    $(document)
      .off('click.ajaxCartSubmit', '.ajax-submit')
      .on('click.ajaxCartSubmit', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document)
      .off('click.ajaxCartDelete', '[data-ajax-cart-delete]')
      .on('click.ajaxCartDelete', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).closest('[data-line-item]').attr('data-line-item');
      const itemKey = $(this).attr('data-cart-item-key');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID, null, itemKey);

      return false;
    });

    $(document)
      .off('click.ajaxCartClose', '[data-ajax-cart-close]')
      .on('click.ajaxCartClose', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      const miniCartTrigger = $(this)
        .closest('.header-cart')
        .find('[data-ajax-cart-trigger]')[0];
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart(miniCartTrigger);

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $carts = $('.header-cart')
      .has('[data-ajax-cart-trigger]')
      .not('.mobile-header .header-cart');

    $carts
      .off('.ajaxCartHover')
      .on('mouseenter.ajaxCartHover focusin.ajaxCartHover', function() {
        $(this).addClass('show-mini-cart');
        $(this).find('[data-ajax-cart-trigger]').attr('aria-expanded', 'true');
      })
      .on('mouseleave.ajaxCartHover focusout.ajaxCartHover', function(e) {
        if (!e.relatedTarget || !this.contains(e.relatedTarget)) {
          $(this).removeClass('show-mini-cart');
          $(this).find('[data-ajax-cart-trigger]').attr('aria-expanded', 'false');
        }
      });
  },
  hideMiniCart: function (trigger, restoreFocus = true) {
    if (this.cart_action != 'mini_cart') return false;
    const closedMobileCart = mobileCart.close(restoreFocus);
    $('.header-cart').removeClass('show-mini-cart');
    $('[data-ajax-cart-trigger]').attr('aria-expanded', 'false');
    if (!closedMobileCart && restoreFocus && trigger && document.documentElement.contains(trigger)) {
      trigger.focus({ preventScroll: true });
    }
  },
  toggleMiniCart: function() {
    const $triggers = $('.mobile-header [data-ajax-cart-trigger]');

    $triggers
      .off('click.ajaxCartMini')
      .on('click.ajaxCartMini', function (e) {
        e.preventDefault();
        const $trigger = $(this);
        const $cart = $trigger.closest('.header-cart');
        const willOpen = !$cart.hasClass('show-mini-cart');

        $('.mobile-header .header-cart')
          .removeClass('show-mini-cart')
          .find('[data-ajax-cart-trigger]')
          .attr('aria-expanded', 'false');

        $cart.toggleClass('show-mini-cart', willOpen);
        $trigger.attr('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) mobileCart.openMiniCart(this);
        else mobileCart.close();
      });
  },
  showDrawer: function (trigger) {
    if (this.cart_action != 'drawer') return false;
    if (trigger) this.drawerTrigger = trigger;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('[data-ajax-cart-trigger]').attr('aria-expanded', 'true');
    const surface = document.querySelector('.mobile-header [data-ajax-cart-drawer]')
      || this.ajaxCartDrawer[0];
    mobileCart.open(surface, this.drawerTrigger);
  },
  hideDrawer: function (restoreFocus = true) {
    if (this.cart_action != 'drawer') return false;
    const closedMobileCart = mobileCart.close(restoreFocus);
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('[data-ajax-cart-trigger]').attr('aria-expanded', 'false');
    if (!closedMobileCart && restoreFocus && this.drawerTrigger && document.documentElement.contains(this.drawerTrigger)) {
      this.drawerTrigger.focus({ preventScroll: true });
    }
  },
  removeFromCart: function (lineID, callback, itemKey) {
    const theme = window.PXUTheme;
    if (theme.cartRemovePending) return false;

    theme.cartRemovePending = true;
    $('[data-cart-remove-error]').remove();
    $('[data-ajax-cart-delete], [data-cart-page-delete]').attr('aria-disabled', 'true');

    const release = function () {
      theme.cartRemovePending = false;
      $('[data-ajax-cart-delete], [data-cart-page-delete]').removeAttr('aria-disabled');
    };
    const showError = function (description) {
      $('<p class="cart-warning__message" role="alert" data-cart-remove-error>')
        .text(description)
        .prependTo('.cart__form, .ajax-cart__form');
    };

    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      // Keys identify the same item even after another item changes position.
      data: itemKey ? { quantity: 0, id: itemKey } : { quantity: 0, line: lineID },
      dataType: 'json',
      success: function (cart) {
        // One mutation owns both views. Keep removal locked until they refresh.
        const cartView = theme.jsCart && theme.jsCart.$section
          ? theme.jsCart.updateView(cart, null)
          : null;
        const views = [cartView, theme.jsAjaxCart.updateView()].filter(Boolean);
        let remainingViews = views.length;
        let refreshErrorShown = false;
        views.forEach(function (view) {
          view.fail(function () {
            if (!refreshErrorShown) {
              showError('Your cart was updated, but the display could not refresh. Please reload the page.');
              refreshErrorShown = true;
            }
          }).always(function () {
            remainingViews -= 1;
            if (remainingViews === 0) release();
          });
        });
        if (views.length === 0) release();

        if (typeof callback === 'function') callback(cart);
      },
      error: function (XMLHttpRequest, textStatus) {
        var response;
        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (parseError) {
          response = null;
        }
        showError(response && typeof response.description === 'string'
          ? response.description
          : 'Unable to remove this item from your cart. Please try again.');
        release();
      }
    });
  },
  scopeAjaxCartIds: function ($container, containerIndex) {
    const scope = ($container.attr('id') || `ajax-cart-${containerIndex}`)
      .replace(/[^a-zA-Z0-9_-]/g, '-');
    const idMap = {};

    $container.find('[id]').each(function () {
      const originalId = this.id;
      const scopedId = `${scope}--${originalId}`;
      idMap[originalId] = scopedId;
      this.id = scopedId;
    });

    const referenceAttributes = ['for', 'aria-controls', 'aria-describedby', 'aria-labelledby'];
    $container.find('[for], [aria-controls], [aria-describedby], [aria-labelledby]').each(function () {
      const element = this;
      referenceAttributes.forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (!value) return;
        const mappedValue = value
          .split(/\s+/)
          .map(reference => idMap[reference] || reference)
          .join(' ');
        element.setAttribute(attribute, mappedValue);
      });
    });
  },
  renderAjaxCartContent: function ($containers, content) {
    const self = this;
    $containers.each(function (index) {
      const $container = $(this);
      $container.html(content);
      self.scopeAjaxCartIds($container, index);
    });
    mobileCart.refresh();
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        window.PXUTheme.jsAjaxCart.renderAjaxCartContent(
          $('[data-ajax-cart-content]'),
          html.content
        );

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();
    // Retain the node if the cart is portaled before the request completes.
    const $mobileContent = $('#ajax-cart__content-mobile-header');

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        window.PXUTheme.jsAjaxCart.renderAjaxCartContent(
          $mobileContent,
          html.content
        );

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          let $triggers = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          // Open synchronously after success; animation events must not be required
          // for mobile access, or reopen a cart the customer has already closed.
          const openedMobileMiniCart = mobileCart.openMiniCart($addToCartBtn[0]);

          function addedToCart() {
            if (openedMobileMiniCart
              || mobileCart.isMobile() && window.PXUTheme.jsAjaxCart.cart_action === 'drawer'
              || mobileCart.openMiniCart($addToCartBtn[0])) {
              $addToCartBtn.find('span').removeClass('fadeInDown');
              return;
            }

            if (!isScreenSizeLarge()) {
              $triggers = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($triggers);
            } else {
              $triggers = $('[data-ajax-cart-trigger]').not('.mobile-header [data-ajax-cart-trigger]');
            }

            $triggers
              .attr('aria-expanded', 'true')
              .closest('.header-cart')
              .addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer(mobileCart.isMobile() ? $addToCartBtn[0] : undefined);
          window.PXUTheme.jsAjaxCart.updateView();

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          let response;
          try {
            response = JSON.parse(XMLHttpRequest.responseText) || {};
          } catch (parseError) {
            response = {};
          }

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            const description = typeof response.description === 'string'
              ? response.description
              : 'Unable to add this item to your cart. Please try again.';
            const safeDescription = $('<div>').text(description.replace('All 1 ', 'All ')).html();
            cartWarning = `<p class="cart-warning__message animated bounceIn">${safeDescription}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    return window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      window.PXUTheme.jsAjaxCart.renderAjaxCartContent(
        $('[data-ajax-cart-content]'),
        html.content
      );

      if (options.item_count > 0) {
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').closest('.header-cart').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        $('.esl-mobile-menu-dialog__cart').addClass('has-cart-count');

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').closest('.header-cart').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        $('.esl-mobile-menu-dialog__cart').removeClass('has-cart-count');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {
    mobileCart.destroy();

    // Clear event listeners in theme editor
    $(document).off('.ajaxCartDrawer');
    $(document).off('.ajaxCartSubmit');
    $(document).off('.ajaxCartDelete');
    $(document).off('.ajaxCartClose');
    $('.header-cart').off('.ajaxCartHover');
    $('.mobile-header [data-ajax-cart-trigger]').off('.ajaxCartMini');
  }
}

/******/ })()
;
